<div class="hamburger-menu-container" [ngClass]="toggleAction ? 'show' : 'hide'">
    <div class="hamburger hamburger--emphatic js-hamburger">
        <div class="hamburger-box">
            <div class="hamburger-inner"></div>
        </div>
    </div>
</div>
